import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nh-footer',
  template: `
  <footer class="app-component footer">
  <div class="">
      <p class="text-center ba text-muted" style="margin-bottom: 0px;">
          Copyright 2021-{{currentYear}} RxAdvance, all rights reserved
      </p>
  </div>
</footer>`
})
export class NhFooterComponent {
  currentYear: number=new Date().getFullYear();

  constructor() {}
  
}
